var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondaryLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "33px",
    viewBox: "0 0 25 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-location-1041848 copy 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5-Page-d'accueil-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Accueil",
    transform: "translate(-935.000000, -1313.000000)",
    fill: "#C73D58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-location-1041848-copy-9",
    transform: "translate(935.000000, 1313.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4440333,4.8940678 C20.0630676,1.77127966 16.4215906,0 12.5,0 C8.5784094,0 4.93693242,1.77127966 2.5559667,4.8940678 C-0.8519889,9.36864407 -0.8519889,15.5677966 2.5559667,20.0423729 L12.5,33 L22.4440333,20.0423729 C25.8519889,15.5677966 25.8519889,9.36864407 22.4440333,4.8940678 Z M12.5,5.63973729 C16.0948848,5.63973729 19.0359843,8.57617797 19.0359843,12.165161 C19.0359843,15.7541441 16.0947914,18.6905847 12.5,18.6905847 C8.90520862,18.6905847 5.96401567,15.7541441 5.96401567,12.165161 C5.96401567,8.57617797 8.90520862,5.63973729 12.5,5.63973729 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryLocation);
export default __webpack_public_path__ + "static/media/secondaryLocation.6131e94bfd196f315a4c07ff2aeea796.svg";
export { ForwardRef as ReactComponent };